import Translations from '../../utils/Translations';
import Flux from '../../flux/Flux';
import PropTypes from 'prop-types';
import { Component } from 'react';
class SocialShareBarEmailContent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			recipient: '',
			message: '',
			emailStatus: '',
		};

		this.setRecipient = this.setRecipient.bind(this);
		this.setMessage = this.setMessage.bind(this);
		this.sendEmail = this.sendEmail.bind(this);
		this.emailSuccess = this.emailSuccess.bind(this);
		this.emailTimeoutFail = this.emailTimeoutFail.bind(this);
		this.emailGeneralFail = this.emailGeneralFail.bind(this);

		Flux.Guest.addEmailSuccessListener(this.emailSuccess);
		Flux.Guest.addEmailGeneralFailListener(this.emailGeneralFail);
		Flux.Guest.addEmailTimeoutFailListener(this.emailTimeoutFail);
	}

	componentWillUnmount() {
		Flux.Guest.removeEmailSuccessListener(this.emailSuccess);
		Flux.Guest.removeEmailGeneralFailListener(this.emailGeneralFail);
		Flux.Guest.removeEmailTimeoutFailListener(this.emailTimeoutFail);
	}

	// Recipient textarea gets changed
	setRecipient(event) {
		this.setState({ recipient: event.target.value });
	}

	// Message textarea gets changed
	setMessage(event) {
		this.setState({ message: event.target.value });
	}

	// Email button action
	sendEmail() {
		Flux.Guest.sendVideoShareEmail(this.state.recipient, this.state.message, this.props.videoId, this.props.guestId);
	}

	// User-Feedback for Email-Success
	emailSuccess() {
		this.setState({ emailStatus: Translations.get('SocialShareEmailSuccess') });
	}

	// User-Feedback for error while sending Email
	emailGeneralFail() {
		this.setState({ emailStatus: Translations.get('SocialShareEmailGeneralFail') });
	}

	// User-Feedback for error due to sending Emails to often(Only once per 15min allowed)
	emailTimeoutFail() {
		this.setState({ emailStatus: Translations.get('SocialShareEmailTimeoutFail') });
	}

	// Define Content of Email-Tab
	render() {
		const shareEmail = (
			<div>
				<div className="social-share-bar social-share-bar__div">
					<label htmlFor="emailTextArea" className="social-share-bar__label">
						{Translations.get('SocialShareTo')}
					</label>
					<input
						type="text"
						id="emailTextArea"
						className="social-share-bar__textarea email recipient"
						value={this.state.recipient}
						onChange={this.setRecipient}
						placeholder="email@mail.net"
					/>
				</div>
				<div className="social-share-bar social-share-bar__div email text">
					<textarea
						className="social-share-bar__textarea email text"
						value={this.state.message}
						onChange={this.setMessage}
						placeholder={Translations.get('SocialShareEmailPlaceholderText')}
					/>
				</div>
				<div>
					<button id="emailSendButton" className="social-share-bar__button email send" onClick={this.sendEmail}>
						{Translations.get('SocialShareEmailButton')}
					</button>
					<label htmlFor="emailSendButton" className="social-share-bar__label emailstatus">
						{this.state.emailStatus}
					</label>
				</div>
			</div>
		);

		let tabContent = '';
		if (this.props.loggedIn) {
			tabContent = <div className="social-share-bar__tabcontent"> {shareEmail}</div>;
		} else {
			tabContent = (
				<div className="social-share-bar__tabcontent">
					<p className="social-share-bar__p">{Translations.get('SocialShareLogin')}</p>
				</div>
			);
		}

		return <div>{tabContent}</div>;
	}
}

SocialShareBarEmailContent.propTypes = {
	videoUrl: PropTypes.string,
	videoTitle: PropTypes.string,
	loggedIn: PropTypes.bool,
	videoId: PropTypes.string,
	guestId: PropTypes.number,
};

export default SocialShareBarEmailContent;
